import React from "react";
import PropTypes from "prop-types";
import { ProfileCard } from "../../atoms";
import { JURY_SPECIAL_MENTIONS } from "./jury-special-mentions";

import "./all-rankings.m.css";

export const GridView = ({
  snapshotByRank,
  visibleItemsForGrid,
  rankingEntitySlug,
  cdnImage,
  isSsr,
  isRankingDetail = false,
  eventAction = "",
  activeYear,
  showJurySpecialMention = false,
}) => (
  <>
    {snapshotByRank.slice(0, visibleItemsForGrid).map((entityData = {}, index) => {
      const entityType = entityData["entity-type"];
      if (entityType === "year") return null;

      return (
        <ProfileCard
          key={`${entityData?.id}-${index}`}
          showRanking={rankingEntitySlug === "most-powerful-women"}
          entityData={entityData}
          customStyleName="entity-detail"
          cdnImage={cdnImage}
          isSsr={isSsr}
          position={index + 1}
          isRankingDetail={isRankingDetail}
          eventAction={eventAction}
        />
      );
    })}
    {rankingEntitySlug === "40under40" && activeYear === "2026" && showJurySpecialMention && (
      <>
        <div styleName="jury-heading-wrapper" style={{textAlign:"center"}}>
          <h2 styleName="jury-heading">Jury Special Mention</h2>
        </div>
        {JURY_SPECIAL_MENTIONS.map((entityData, index) => (
          <ProfileCard
            key={entityData.id}
            showRanking={false}
            entityData={entityData}
            customStyleName="entity-detail"
            cdnImage={cdnImage}
            isSsr={isSsr}
            position={snapshotByRank.length + index + 1}
            isRankingDetail={isRankingDetail}
            eventAction={eventAction}
            disableLink={!entityData.slug}
          />
        ))}
      </>
    )}
  </>
);

GridView.propTypes = {
  snapshotByRank: PropTypes.array.isRequired,
  visibleItemsForGrid: PropTypes.number.isRequired,
  rankingEntitySlug: PropTypes.string,
  cdnImage: PropTypes.string.isRequired,
  isSsr: PropTypes.bool,
  isRankingDetail: PropTypes.bool,
  eventAction: PropTypes.string,
  activeYear: PropTypes.string,
  showJurySpecialMention: PropTypes.bool,
};
